import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { AuthContext } from "../../context/AuthContext";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import NextList from "../nextList/NextList";
import "./SingleArticle.scss";
import Comments from "../comments/Comments";
import ModalOverlay from "../modalOverlay/ModalOverlay";
import mockupData from "../../database-mockup.json";

function SingleArticle() {
  const { id } = useParams();

  // Convert id to a number
  const current_post_id = Number(id);

  const comment = mockupData.commentsData;
  const post = mockupData.postData;
  const user = mockupData.usersData;

  const location = useLocation();

  const postId = location.pathname.split("/")[2];

  const { currentUser } = useContext(AuthContext);

  function stripTags(str) {
    str = str.replace("<p>", "");
    str = str.replace("</p>", " ");
    return str;
  }
  const [isModalOpen, setIsModalOpen] = useState(true);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const deleteHandler = () => {
    console.log("delete!");
  };

  const foundPost = post.filter((item) => item.id === current_post_id);
  if (foundPost.length > 0) {
    console.log("empty in found post", Number(id));
  } else {
    // Handle the case where the post is not found
  }
  const foundComments = comment.filter(
    (item) => item.postID === current_post_id
  );
  const foundAuthor = user.filter((item) => item.id === foundPost[0].userID);

  return (
    <div className="singleArticle">
      <div className="singleArticle__content">
        <h2 className="singleArticle__content__title">{foundPost[0].title} </h2>

        <img
          className="singleArticle__content__img"
          src={`../upload/${foundPost[0].imgURL}`}
          alt={`a post named ${foundPost[0].title}`}
        />

        {/* Author details and other options */}
        <div className="singleArticle__author">
          <div className="singleArticle__user">
            <img
              className="singleArticle__user__img"
              src={`../upload/${foundAuthor[0].image}`}
              alt="user image"
            />
          </div>
          <div className="singleArticle__info">
            <span className="singleArticle__info__name">
              {foundAuthor[0].username}
            </span>
            <span className="singleArticle__info__date">
              Posted {foundPost[0].date}
            </span>
          </div>
          {currentUser.username === post.username && (
            <div className="singleArticle__icons">
              <Link
                className="singleArticle__icons__link"
                to={`/write?edit=${postId}`}
                state={post}
              >
                <EditIcon />
              </Link>
              <DeleteIcon
                onClick={deleteHandler}
                sx={{ color: "skyBlue", cursor: "pointer" }}
              />
            </div>
          )}
        </div>

        {/* Post content */}
        {/* <p className="singleArticle__item__text">{foundPost[0].content}</p> */}
        <div dangerouslySetInnerHTML={{ __html: foundPost[0].content }}></div>
      </div>

      <div className="singleArticle__sideMenu">
        <NextList category={foundPost[0].category} current={current_post_id} />
      </div>

      <div className="singleArticle__comments">
        <Comments foundComments={foundComments} />
      </div>
      {/* <ModalOverlay
        isOpen={isModalOpen}
        onClose={closeModal}
        message="Can't connect to the backend in this demo. Want to explore my GitHub repo?"
        githubRepoUrl={"https://github.com/jclairelee/liv_client"}
      /> */}
    </div>
  );
}

export default SingleArticle;
